module.exports = __webpack_public_path__ + "img/btnStatus8.2aa3cd17.png";